const GENERIC_TEXT = 'Please refresh the page and if the error persists please contact support'

/**
 * Turn a rejected axios error into a notification payload for this.$notify().
 *
 * Returns a plain object rather than notifying directly so the mapping can be
 * unit-tested without a mounted Vue app, and so each caller decides where the
 * message is shown.
 */
export function buildHttpErrorNotification(error) {
  const response = error && error.response

  if (!response) {
    return {
      title: '<h4>Connection problem</h4>',
      type: 'error',
      text: 'We could not connect to the server. Check your connection and try again.',
      duration: -1,
      group: '',
    }
  }

  const statusCode = response.status
  let title = ''
  let group = ''
  let text = GENERIC_TEXT
  let duration = -1 // forever

  if (statusCode >= 500) {
    title = '<h4>Server error</h4>'
  }

  if (statusCode >= 400 && statusCode < 500) {
    title = '<h4>Application error</h4>'
  }

  if (statusCode === 401) {
    title = '<h4>Unauthorized</h4>'
    text = 'You are unauthorized to make that request'
  }

  if (statusCode === 403) {
    title = '<h4>Not permitted</h4>'
    text = 'You do not have permission to perform that action. Ask a super admin to run it for you.'
  }

  if (statusCode === 419) {
    title = '<h4>Session expired</h4>'
    text = 'Your session expired. Please reload the page and sign in again.'
  }

  if (statusCode === 422) {
    title = '<h5>Validation Error</h5>'
    const data = response.data

    if (data) {
      if (data.errors) {
        text = Object.keys(data.errors)
          .map((field) => data.errors[field][0])
          .join('<br>')
      }

      if (data.notificationGroup) {
        group = data.notificationGroup
      }
    }

    duration = 6000
  }

  return { title, type: 'error', text, duration, group }
}
